var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuperannuation = function SvgSuperannuation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.98 28.7C47.98 28.7 53.45 26.23 54.16 23.18C54.92 19.94 50.39 19.04 50.32 23.1C50.24 27.71 55.44 28.84 55.44 28.84",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.63 31.01C47.78 30.38 47.82 30.08 47.87 29.44L47.89 28.14C47.55 19.65 40.53 12.85 31.96 12.85C31.45 12.85 27.51 12.83 26.14 12.85C25.72 12.12 25.2 11.44 24.53 10.78C22.68 8.93 20.23 7.92 17.62 7.92C17.41 7.92 17.21 8.02 17.09 8.2C16.97 8.37 16.94 8.59 17.01 8.79L17.19 9.3C17.83 11.12 17.81 13.1 17.12 14.9C13.86 16.31 11.19 18.35 9.33999 20.83H5.84999C4.76999 20.83 3.89999 21.71 3.89999 22.78V32.35C3.89999 33.43 4.77999 34.3 5.84999 34.3H8.05999C9.13999 36.43 10.85 38.38 13.02 39.97V45.29C13.02 46.37 13.9 47.24 14.97 47.24H20.18C21.26 47.24 22.13 46.36 22.13 45.29V44.05C22.13 42.97 23.01 42.1 24.08 42.1H29.07",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.89 23.55C18.8289 23.55 19.59 22.7889 19.59 21.85C19.59 20.9111 18.8289 20.15 17.89 20.15C16.9511 20.15 16.19 20.9111 16.19 21.85C16.19 22.7889 16.9511 23.55 17.89 23.55Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.86 52.24C47.22 52.24 51.56 47.9 51.56 42.54C51.56 37.18 47.22 32.84 41.86 32.84C36.5 32.84 32.16 37.18 32.16 42.54C32.16 47.9 36.5 52.24 41.86 52.24Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.86 36.07V37.92",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.86 47.16V49.01",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.09 47.16H43.25C43.86 47.16 44.45 46.92 44.88 46.48C45.31 46.05 45.56 45.46 45.56 44.85C45.56 44.24 45.32 43.65 44.88 43.22C44.45 42.79 43.86 42.54 43.25 42.54H40.48C39.87 42.54 39.28 42.3 38.85 41.86C38.42 41.43 38.17 40.84 38.17 40.23C38.17 39.62 38.41 39.03 38.85 38.6C39.28 38.17 39.87 37.92 40.48 37.92H44.64",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.62 17.97H36.58",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuperannuation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/superannuation.svg";